import React from 'react';
import { Modal } from 'library/ui';
import { AddPaymentMethod } from './AddPaymentMethod';
import { PaymentMethod, PaymentProduct } from './types';

type SupportedKind = 'card' | 'bank';

interface AddPaymentMethodModalProps {
    open: boolean;
    onClose: () => void;
    onSuccess?: (method: PaymentMethod) => void;
    allowedKinds?: SupportedKind[];
    title?: string;
    product?: PaymentProduct;
}

export function AddPaymentMethodModal({
    open,
    onClose,
    onSuccess,
    allowedKinds = ['card', 'bank'],
    title = 'Add Payment Method',
    product = 'subs',
}: AddPaymentMethodModalProps) {
    if (!open) return null;
    return (
        <Modal title={title} onClose={onClose} width={520}>
            <AddPaymentMethod
                allowedKinds={allowedKinds}
                onSuccess={(method) => {
                    onSuccess?.(method);
                    onClose();
                }}
                onCancel={onClose}
                product={product}
            />
        </Modal>
    );
}
